// import { API_BASEURL } from "../../config/axiosInstance";
// import useWebSocketStore from "../useWebSocketStore";

// export const startingRecordHandler = (state, session) => {
//   state({
//     isRecording: true,
//     isPaused: false,
//     recordingStatus: "listening",
//   });
// };

// export const pausedRecordHandler = (state, session) => {
//   state({
//     isPaused: true,
//     recordingStatus: "paused",
//     currentSession: { ...session, status: "paused" },
//   });
// };

// export const resumedRecordHandler = (state, session) => {
//   state({
//     isPaused: false,
//     recordingStatus: "listening",
//     currentSession: { ...session, status: "active" },
//   });
// };

// export const stoppedRecordHandler = async (state, get, session, data) => {
//   const { currentReport, transcript, auth, audioSource } = get();

//   state({
//     isRecording: false,
//     isPaused: false,
//     isProcessingSpeech: false,
//     recordingStatus: "ready",
//     // transcript: [],
//     // currentReport: "",
//     // currentSession: null,
//   });

//   try {
//     const payload = {
//       url: `${API_BASEURL}/api/v1/sessions/${session._id}`,
//       filepath: data.audio_info.filepath.split('sessions\\')?.[1] ? 'sessions\\' + data.audio_info.filepath.split('sessions\\')?.[1] : data.audio_info.filepath,
//       size: data.audio_info.size,
//       session_id: session._id,
//       provider: data.provider,
//       audioSource: audioSource,
//       language: "en-US",
//       duration: data.audio_info.duration,
//       word_count: transcript.reduce((count, segment) => {
//         return count + (segment.text?.split(" ").length || 0);
//       }, 0),
//       // report: currentReport ? currentReport : "",
//       segments: transcript?.length > 0 ? JSON.stringify(transcript) : "[]",
//       format: data?.audio_info?.format || "wav",
//       audio_duration: data.audio_info.duration,
//       token: localStorage.getItem("access_token") || auth?.access_token || "",
//     };

//     if (window.pywebview?.api) {
//       await window.pywebview?.api.upload_file(payload);
//       await get().getSessions();
//       await get().setCurrentSession(session._id);

//     }
//   } catch (error) {
//     console.log(error);
//   }

//   //   get().refreshSessions();
// };

// export const handleTranscription = (set, get, data) => {
//   const { currentSession } = get();

//   if (!currentSession) return;

//   const existingSegments = currentSession.segments || [];

//   const enhancedSegment = {
//     ...data,
//     wordCount: data.text ? data.text.split(" ").length : 0,
//     isNewSentence: data.text ? /^[A-Z]/.test(data.text.trim()) : false,
//     endsWithPunctuation: data.text ? /[.!?]$/.test(data.text.trim()) : false,
//     id:
//       data.id ||
//       `${data.provider}_${Date.now()}_${Math.random()
//         .toString(36)
//         .substr(2, 9)}`,
//     timestamp: data.timestamp || Date.now() / 1000,
//     session_timestamp: data.session_timestamp,
//     is_final: data.is_final !== false,
//     provider: data.provider || "unknown",
//     text: data.text || "",
//     confidence: data.confidence,
//     duration: data.duration,
//     processing_time: data.processing_time,
//   };




//   useWebSocketStore.getState().emit('real-time-suggestion', {
//     data: {
//       text: data.text
//     }
//   })


//   if (!enhancedSegment.is_final) {
//     const finalSegments = existingSegments.filter((seg) => seg.is_final);
//     const updatedSegments = [...finalSegments, enhancedSegment];

//     set({
//       transcript: updatedSegments,
//       currentSession: {
//         ...currentSession,
//         segments: updatedSegments,
//       },
//     });
//   } else {
//     const finalSegments = existingSegments.filter((seg) => seg.is_final);
//     const updatedSegments = [...finalSegments, enhancedSegment];

//     set({
//       transcript: updatedSegments,
//       currentSession: {
//         ...currentSession,
//         segments: updatedSegments,
//       },
//     });
//   }
// };


import { API_BASEURL } from "../../config/axiosInstance";
import useWebSocketStore from "../useWebSocketStore";

export const startingRecordHandler = (state, session) => {
  state({
    isRecording: true,
    isPaused: false,
    recordingStatus: "listening",
  });
};

export const pausedRecordHandler = (state, session) => {
  state({
    isPaused: true,
    recordingStatus: "paused",
    currentSession: { ...session, status: "paused" },
  });
};

export const resumedRecordHandler = (state, session) => {
  state({
    isPaused: false,
    recordingStatus: "listening",
    currentSession: { ...session, status: "active" },
  });
};

export const stoppedRecordHandler = async (state, get, session, data, liveTranscript) => {
  const { auth, audioSource } = get();
  const transcript = liveTranscript || get().transcript;

  state({
    isRecording: false,
    isPaused: false,
    isProcessingSpeech: false,
    recordingStatus: "ready",
  });

  if (!data?.audio_info?.filepath) {
    console.warn("stoppedRecordHandler: audio_info missing, skipping upload");
    await get().getSessions();
    return;
  }

  try {
    const finalSegments = transcript.filter(s => !s._id && s.is_final && s.text?.trim());
    const mergedText = finalSegments.map(s => s.text).join(' ');
    const lastSegment = finalSegments[finalSegments.length - 1];
    const singleSegment = lastSegment ? [{ ...lastSegment, text: mergedText }] : [];

    const payload = {
      url: `${API_BASEURL}/api/v1/sessions/${session._id}`,
      filepath: data.audio_info.filepath.split('sessions\\')?.[1]
        ? 'sessions\\' + data.audio_info.filepath.split('sessions\\')?.[1]
        : data.audio_info.filepath,
      size: data.audio_info.size,
      session_id: session._id,
      provider: data.provider,
      audioSource: audioSource,
      language: "en-US",
      duration: data.audio_info.duration,
      word_count: mergedText.split(" ").length,
      segments: singleSegment.length > 0 ? JSON.stringify(singleSegment) : "[]",
      format: data?.audio_info?.format || "wav",
      audio_duration: data.audio_info.duration,
      token: localStorage.getItem("access_token") || auth?.access_token || "",
    };

    if (window.pywebview?.api) {
      await window.pywebview?.api.upload_file(payload);
      await get().getSessions();
      // No setCurrentSession — keeps 2 divs during processing
      // setCurrentSession is called inside final_transcription after OpenAI completes
    }
  } catch (error) {
    console.log(error);
  }
};

export const handleTranscription = (set, get, data) => {
  const { currentSession, audioSource } = get();

  if (!currentSession) return;

  const existingSegments = currentSession.segments || [];

  const enhancedSegment = {
    ...data,
    // audioSource: audioSource,
    wordCount: data.text ? data.text.split(" ").length : 0,
    isNewSentence: data.text ? /^[A-Z]/.test(data.text.trim()) : false,
    endsWithPunctuation: data.text ? /[.!?]$/.test(data.text.trim()) : false,
    id:
      data.id ||
      `${data.provider}_${Date.now()}_${Math.random()
        .toString(36)
        .substr(2, 9)}`,
    timestamp: data.timestamp || Date.now() / 1000,
    session_timestamp: data.session_timestamp,
    is_final: data.is_final !== false,
    provider: data.provider || "unknown",
    text: data.text || "",
    confidence: data.confidence,
    duration: data.duration,
    processing_time: data.processing_time,
    audioSource: data.audioSource || audioSource || 'microphone',
  };




  const wsStore = useWebSocketStore.getState();
  if (wsStore.isReady()) {
    wsStore.emit('real-time-suggestion', { data: { text: data.text } });
  }


  if (!enhancedSegment.is_final) {
    const finalSegments = existingSegments.filter((seg) => seg.is_final);
    const updatedSegments = [...finalSegments, enhancedSegment];

    set({
      transcript: updatedSegments,
      currentSession: {
        ...currentSession,
        segments: updatedSegments,
      },
    });
  } else {
    const finalSegments = existingSegments.filter((seg) => seg.is_final);
    const updatedSegments = [...finalSegments, enhancedSegment];

    set({
      transcript: updatedSegments,
      currentSession: {
        ...currentSession,
        segments: updatedSegments,
      },
    });
  }
};